import { useState, useEffect, useRef, useCallback } from 'react';
import { searchStocks } from '../../utils/api';

export default function SearchBar({ onSelect, placeholder = 'Search stocks...' }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const containerRef = useRef(null);

  const search = useCallback(async (q) => {
    if (!q || q.length < 1) { setResults([]); return; }
    setLoading(true);
    try {
      const data = await searchStocks(q);
      setResults(data.slice(0, 8));
      setOpen(true);
    } catch { setResults([]); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => search(query), 250);
    return () => clearTimeout(timerRef.current);
  }, [query, search]);

  useEffect(() => {
    const handler = (e) => { if (!containerRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSelect = (item) => {
    setQuery('');
    setOpen(false);
    setResults([]);
    onSelect(item.symbol);
  };

  return (
    <div className="search-container" ref={containerRef}>
      <input
        className="input"
        value={query}
        onChange={e => setQuery(e.target.value)}
        placeholder={placeholder}
        onFocus={() => results.length > 0 && setOpen(true)}
      />
      {open && results.length > 0 && (
        <div className="search-dropdown">
          {results.map(r => (
            <div key={r.symbol} className="search-item" onMouseDown={() => handleSelect(r)}>
              <div>
                <span style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, color: 'var(--accent)' }}>{r.symbol}</span>
                <span style={{ marginLeft: 8, color: 'var(--text-secondary)', fontSize: 12 }}>{r.name}</span>
              </div>
              <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{r.exchange}</span>
            </div>
          ))}
        </div>
      )}
      {loading && <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: 11 }}>...</div>}
    </div>
  );
}
